import React, { forwardRef } from 'react';
import { mergeProps } from '@react-aria/utils';
export default function makeBasicElement(baseAs, className, defaultProps = {}) {
    function Element({ as: newAs, ...extra }, ref) {
        const As = newAs || baseAs;
        return React.createElement(As, Object.assign({ ref: ref }, mergeProps(defaultProps, extra, { className })));
    }
    Element.displayName = `Paint(${baseAs.toString()})`;
    return forwardRef(Element);
}
